module.exports = __webpack_public_path__ + "media/icons/ilosc-miejsc-b2002ab0.png";